import React, { useContext, useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { IoNotificationsOutline } from "react-icons/io5";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import NotVerified from "./NotVerified";
import Error from "./Error";
import Dashboard from "./Dashboard";
import WithOutAccount from "./WithOutAccount";
import Withdraw from "./Views/Withdraws/Withdraw";
import Offer from "./Views/Offers/Offer";
import RecivedChat from "./Views/Offers/RecivedChat";
import SentChat from "./Views/Offers/SentChat";
import RequestOverview from "./Views/Offers/RequestOverview";
import CreateRequest from "./Views/Request/CreateRequest.";
import CreateOffer from "./Views/CreateOffer/CreateOffer";
import OfferDetail from "./Views/CreateOffer/OfferDetail";
import OfferUser from "./Views/CreateOffer/OfferUser";
import OfferOverview from "./Views/CreateOffer/OfferOverview";
import OfferSuccess from "./Views/CreateOffer/OfferSuccess";
import BillingHistory from "./Views/BillingHistory/BillingHistory";
import MyProfile from "./Views/Profile/MyProfile";
import MainChat from "./Views/Message/MainChat";
import ChatDetail from "./Views/Message/ChatDetail";
import Service from "./Views/Marketplace/Service/Service";
import Marketplace from "./Views/Marketplace/Marketplace/Marketplace";
import Adds from "./Views/Adds/Adds";
import AllReview from "./Views/Marketplace/Service/AllReview";
import WithdrawHistory from "./WithdrawHistory";
import { includeTexts } from "../../Files/DashboardControl";
import BusinessDashboard from "./BusinessDashboard";
import MissingDoc from "./Views/MissingDoc/MissingDoc";
import UploadMissing from "./Views/MissingDoc/UploadMissing";
import AlertContext from "../../Context/Alert/AlertContext";
import axios from "axios";
import { BaseURL } from "../../Files/BaseURL";
import SocketContext from "../../Context/Socket/SocketContext";
import io from "socket.io-client";
import ThemeContext from "../../Context/theme/ThemeContext";
import { menu } from "../../Files/Menu";
import MainTicket from "./Views/Cases/MainTicket";
import UserContext from "../../Context/User/UserContext";

const UserDashboard = () => {
  const { theme } = useContext(ThemeContext);

  const [MarketPlace, setMarketPlace] = useState(false);
  const [User, setUser] = useState("");
  const [AccountCheck, setAccountCheck] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const { userDetail, setUserDetail } = useContext(UserContext);

  const socketContext = useContext(SocketContext);
  const { setSocetConnection, setOnlineUsers } = socketContext;

  const fetchUser = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(`${BaseURL}/api/user/userstatus`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });

      if (response.data) {
        setUser(response.data);
        setUserDetail(response.data);
        const routeMap = {
          Pending: "/user-dashboard/upl_missing_doc",
          Request: "/user-dashboard/not-verify",
          Declined: "/user-dashboard/error",
        };
        navigate(routeMap[response.data.Verification]);
      } else {
        showAlert("No pending documents found", "info");
      }
    } catch (error) {
    
      showAlert("Error fetching pending documents", "danger");
    }
  };

  const fetchAccountCheck = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/payment/account/accountcheck`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        setAccountCheck(true);
      } else {
        navigate("/user-dashboard/no-account");
        setAccountCheck(false);
      }
    } catch (error) {
      showAlert("Error fetching Account Check", "danger");
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("p@token")) {
      navigate("/signinemail");
      return;
    }
    if (User.Verification !== "Approved") {
      const routeMap = {
        Pending: "/user-dashboard/upl_missing_doc",
        Request: "/user-dashboard/not-verify",
        Declined: "/user-dashboard/error",
      };
      navigate(routeMap[User?.Verification]);
      return;
    }
    if (!AccountCheck) {
      navigate("/user-dashboard/no-account");
    }
  }, [location.pathname]);

  useEffect(() => {
    fetchUser();
    fetchAccountCheck();
    const authToken = localStorage.getItem("p@token");
    const socketConnection = io(BaseURL, {
      auth: {
        token: authToken,
      },
    });
    setSocetConnection(socketConnection);
    socketConnection.on("onlineUser", (data) => {
      setOnlineUsers(data);
    });
    return () => {
      socketConnection.disconnect();
    };
  }, []);

  const logout = () => {
    localStorage.removeItem("p@token");
    navigate("/");
  };

  const handleCreateOffer = () => {
    if (!AccountCheck) {
      showAlert("Please connect your account first", "warning");
      navigate("/user-dashboard/no-account");
      return;
    }
    navigate("/user-dashboard/create_offer");
  };

  const handleRequestJob = () => {
    if (!AccountCheck) {
      showAlert("Please connect your account first", "warning");
      navigate("/user-dashboard/no-account");
      return;
    }
    navigate("/user-dashboard/create_request");
  };

  return (
    <>
      <div className="flex flex-row max-h-[100vh] overflow-hidden max-w-screen min-h-[100vh] bg-[#f3f3f3]">
        <div
          className={`relative hidden xl:block xl:basis-[15%] ${
            theme == "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <div
            className={`py-6 xl:flex flex-col hidden justify-center items-center ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }`}
          >
            <Link to={"/user-dashboard"}>
              <h1 className="ml-2 oxygen-bold text-lg md:text-xl lg:text-3xl animate__animated animate__backInLeft animate__slow cursor-pointer">
                paycott.
              </h1>
            </Link>
          </div>
          <div className="my-6 flex flex-col gap-2">
            {menu?.map((item, index) => (
              <>
                {item?.type !== "Main" ? (
                  <Link to={item.to} key={index}>
                    <div
                      className={`flex flex-row items-center gap-2 px-2 md:px-8 py-4 text-gray-400 
                        ${
                          location.pathname == item.to &&
                          "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                        }
                        ${theme == "dark" ? "bg-black text-white" : "bg-white "}
                      `}
                    >
                      <item.icon className="text-2xl" />
                      <h2 className={`font-pop hidden xl:block text-base `}>
                        {item.link}
                      </h2>
                    </div>
                  </Link>
                ) : (
                  <div>
                    <div
                      className={`flex flex-row items-center cursor-pointer gap-2 px-2 md:px-8 py-4 text-gray-400 ${
                        location.pathname === item.to &&
                        "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                      } ${
                        theme == "dark" ? "bg-black text-white" : "bg-white "
                      }`}
                      onClick={() => {
                        setMarketPlace(!MarketPlace);
                      }}
                    >
                      <item.icon className="text-2xl" />
                      <h2
                        className={`font-pop hidden xl:block text-base ${
                          theme == "dark" ? "bg-black text-white" : "bg-white "
                        }`}
                      >
                        {item.link}
                      </h2>
                    </div>
                    {MarketPlace && (
                      <div className="py-1 flex flex-col gap-1">
                        {item?.SubLink?.map((item2, index2) => (
                          <Link to={item2.to} key={index2}>
                            <div
                              className={`flex flex-row items-center gap-2 px-2 md:px-8 py-2 text-gray-400 ${
                                location.pathname == item2.to &&
                                "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                              }${
                                theme == "dark"
                                  ? "bg-black text-white"
                                  : "bg-white "
                              }`}
                            >
                              <item.icon className="text-2xl opacity-0" />
                              <h2
                                className={`font-pop hidden xl:block text-base`}
                              >
                                {item2.link}
                              </h2>
                            </div>
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
        <div
          className={`basis-[100%] max-w-[100vw] xl:max-w-[85vw] overflow-hidden xl:basis-[85%] bg-[#f3f3f3] ${
            theme == "dark" ? "bg-gray-700 text-white" : "bg-gray-200 "
          }`}
        >
          <div
            className={` w-full py-2 md:py-6 px-2 md:px-6 flex flex-row items-center justify-between  ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }`}
          >
            <h2
              className={`font-pop text-base md:text-xl font-bold ${
                theme == "dark" ? "bg-black text-white" : "bg-white "
              }`}
            >
              {includeTexts.some((text) =>
                window.location.pathname.includes(text)
              ) ? (
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="cursor-pointer"
                >
                  <span>&#60;</span> Go Back
                </div>
              ) : (
                "Dashboard"
              )}
            </h2>
            <div className="flex flex-row gap-3 items-center">
              <div className=" hidden md:flex flex-row gap-2 items-center">
                <button
                  className="bg-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer"
                  onClick={handleRequestJob}
                >
                  Request a job
                </button>
                <button
                  className="bg-primarygreen rounded-full font-pop text-white py-2 px-5 cursor-pointer"
                  onClick={handleCreateOffer}
                >
                  Create offer
                </button>
              </div>
              <div className="bg-gray-100 lg:block hidden font-semibold rounded-full p-2 text-primarygreen font-pop text-lg">
                en
              </div>
              <div className="bg-gray-100 lg:block hidden font-semibold rounded-full p-2 text-gray-600 font-pop text-2xl">
                <IoNotificationsOutline />
              </div>
              <div className="flex flex-row gap-2 items-center group cursor-pointer relative">
                {User?.ProfilePhoto ? (
                  <img
                    src={User?.ProfilePhoto}
                    alt=""
                    className="rounded-full w-8 md:w-12 h-8 md:h-12"
                  />
                ) : (
                  <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                    <span className={`text-white `}>
                      {User && User?.FirstName?.charAt(0)}
                    </span>
                  </div>
                )}
                <h2 className="font-pop text-base md:text-lg font-semibold">
                  {User.FirstName} {User.LastName}
                </h2>
                <FaChevronDown className="text-lg" />
                <div
                  className={`group-hover:flex hidden rounded-xl z-[99] right-0 w-[100%] flex-col gap-2 b absolute top-[100%] shadow-2xl  font-pop text-lg font-medium py-2 px-4
                ${theme == "dark" ? "bg-black text-white" : "bg-white "}`}
                >
                  <Link to={"/user-dashboard/profile/"}>
                    <h3>Profile</h3>
                  </Link>
                  <Link to={"/user-dashboard/profile/setting"}>
                    <h3>Setting</h3>
                  </Link>
                  <h3 className="cursor-pointer" onClick={logout}>
                    SignOut
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="flex max-w-full max-h-[100%] relative">
            <div className={`bg-white xl:hidden`}>
              <div className="my-6 flex flex-col gap-2">
                {menu?.map((item, index) => (
                  <>
                    {item?.type !== "Main" ? (
                      <Link to={item.to} key={index}>
                        <div
                          className={`flex flex-row items-center gap-2 px-2 md:px-8 py-4 text-gray-400 ${
                            location.pathname === item.link &&
                            "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                          }`}
                        >
                          <item.icon className="text-2xl" />
                        </div>
                      </Link>
                    ) : (
                      <div>
                        <div
                          className={`flex flex-row items-center gap-2 px-2 md:px-8 py-4 text-gray-400 ${
                            location.pathname === item.link &&
                            "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                          }`}
                          onClick={() => {
                            setMarketPlace(!MarketPlace);
                          }}
                        >
                          <item.icon className="text-2xl" />
                        </div>
                        {MarketPlace && (
                          <div className="py-1 flex flex-col gap-1">
                            {item?.SubLink?.map((item2, index2) => (
                              <Link to={item2.to} key={index2}>
                                <div
                                  className={`flex flex-row items-center gap-2 px-2 md:px-8 py-4 text-gray-400 ${
                                    location.pathname === item.link &&
                                    "bg-primarygreen/20 text-primarygreen border-l-4 border-primarygreen"
                                  }`}
                                >
                                  <item2.icon className="text-2xl" />
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
            <div className="w-[95%] max-h-[calc(100vh-100px)]  overflow-y-auto md:w-[95%] xl:w-[100%]">
              <Routes>
                <Route
                  path="/"
                  element={
                    User?.BusinessAccount == "Approve" ||
                    userDetail?.BusinessAccount == "Approve" ? (
                      <BusinessDashboard />
                    ) : (
                      <Dashboard />
                    )
                  }
                />

                <Route path="/withdraw-history" element={<WithdrawHistory />} />
                <Route path="/no-account" element={<WithOutAccount />} />

                <Route path="/not-verify" element={<NotVerified />} />
                <Route path="/error" element={<Error />} />
                <Route path="/pendingDoc" element={<MissingDoc />} />
                <Route path="/upl_missing_doc" element={<UploadMissing />} />

                <Route path="/billing_history" element={<BillingHistory />} />

                <Route path="/withdraw/*" element={<Withdraw />} />

                <Route path="/offers/*" element={<Offer />} />
                <Route
                  path="/offers/recivedchat/:recivedid"
                  element={<RecivedChat />}
                />
                <Route path="/offers/sendchat/:sentid" element={<SentChat />} />
                <Route
                  path="/offers/request_overview/:id"
                  element={<RequestOverview />}
                />

                <Route path="/ticket/*" element={<MainTicket />} />

                <Route path="/create_request/*" element={<CreateRequest />} />

                <Route path="/create_offer" element={<CreateOffer />} />
                <Route path="/offer_detail" element={<OfferDetail />} />
                <Route path="/offer_user" element={<OfferUser />} />
                <Route path="/offer_overview" element={<OfferOverview />} />
                <Route path="/offer_success" element={<OfferSuccess />} />

                <Route path="/service/*" element={<Service />} />

                <Route path="/marketplace/*" element={<Marketplace />} />
                <Route path="/adds/*" element={<Adds />} />

                <Route path="/profile/*" element={<MyProfile />} />
                <Route path="/rating/:userId" element={<AllReview />} />

                <Route path="/chat" element={<MainChat />} />
                <Route path="/chat-detail" element={<ChatDetail />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDashboard;
